// extracted by mini-css-extract-plugin
module.exports = {"container":"generalLayout_container__Y5Zwj","row":"generalLayout_row__Ckhzv"};